import classnames from 'classnames';
import { isString, noop } from 'ramda-adjunct';
import React, { FC, useCallback, useState } from 'react';
import { TextButton } from '../index';
import styles from './HelpLink.scss';
import { IOuter } from './HelpLink.types';
import { HelpModal } from './HelpModal';

export const HelpLink: FC<IOuter> = ({
  article: articleFromProps,
  Component = TextButton,
  onClick = noop,
  dataHook = 'help-link',
  className,
  ...otherProps
}) => {
  const [article, setArticle] = useState(null);

  const openHelpModal = useCallback(
    (event) => {
      setArticle(articleFromProps);
      onClick(event);
      event.stopPropagation();
    },
    [articleFromProps, onClick],
  );

  const closeHelpModal = useCallback(() => setArticle(null), []);

  const commonProps = {
    onClick: openHelpModal,
    ...otherProps,
    [isString(Component) ? 'data-hook' : 'dataHook']: dataHook,
  };

  return (
    <>
      {Component === TextButton ? (
        <TextButton as="a" className={classnames(styles.textButtonHelpLink, className)} {...commonProps} />
      ) : (
        <Component className={className} {...commonProps} />
      )}

      <HelpModal article={article} onClose={closeHelpModal} />
    </>
  );
};
